// The caller and the way out. The components never see the api: App calls
// these hooks and hands the result to src/features/auth/adapt.ts.
import { useMutation, useQuery } from "@tanstack/react-query";

import { api, ApiError, newRequestId, unwrap, windowNavigation } from "../../api/client";
import { keys } from "../../api/keys";
import { runtimeConfig } from "../../config/runtime";
import { logoutUrlOf } from "./adapt";

/** GET /me: who is signed in. With entra it is also the question "am I signed in?" (200 or 401). */
export function useMe() {
  return useQuery({
    queryKey: keys.me,
    queryFn: async () => unwrap((await api().GET("/api/v1/me")).data),
    staleTime: Infinity,
    // the start of the app waits on it: a failure shows «Riprova», not three attempts
    retry: false,
  });
}

/** The path of the sign-out; the contract of the api in dev mode does not have it, so it is not in schema.d.ts. */
export const LOGOUT_PATH = "/api/v1/auth/logout";

/** POST /auth/logout, then the whole window to the Entra end-session address. */
export function useLogout() {
  return useMutation({
    mutationFn: async () => {
      const config = runtimeConfig();
      const response = await fetch(`${config.apiBase}${LOGOUT_PATH}`, {
        method: "POST",
        credentials: "same-origin",
        headers: { "X-Request-ID": newRequestId() },
      });
      if (!response.ok) throw new ApiError(response.status, null, response.headers.get("x-request-id"));
      const url = logoutUrlOf(await response.json());
      if (url === null) throw new Error("the sign-out answered without a logout_url");
      return url;
    },
    onSuccess: (url) => windowNavigation.assign(url),
  });
}
